import { styled } from "styled-components";
import Button from "../Button/Button";

const MenuButton = styled(Button).attrs({ variant: 'text', scale: 'xs' })`
  width: 50px;
  padding: 0;
`;

export default MenuButton;
